import { baseAuthApi } from "../../../../core/service/baseApi";

type FetchedConfig = { list: Record<string, string>[] };

export const profilesApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchProfiles: builder.query<FetchedConfig, string>({
            providesTags: ["mainCache"],
            query: (url) => ({
                url,
                method: "GET",
            }),
        }),
    }),
});

export const { useFetchProfilesQuery } = profilesApi;
